import posthog from 'posthog-js';

/** Caught failures do not reach the React error boundary. Keep payloads content-free. */
export function reportOnboardingFailure(operation: string, workspaceId?: string | null, status?: number, error?: unknown): void {
  if (process.env.REACT_APP_POSTHOG_DISABLED === 'true') return;
  try {
    posthog.capture('onboarding_failure', {
      operation, workspaceId, ...(status === undefined ? {} : { status }),
      ...(error === undefined ? {} : { failureKind:
        status !== undefined ? 'http' :
        error instanceof Error && ['TimeoutError', 'AbortError'].includes(error.name) ? 'timeout' :
        error instanceof TypeError ? 'network' : 'unknown',
      }),
      // Handoff URLs may contain pasted text and claim tokens.
      $current_url: `${window.location.origin}${window.location.pathname}`,
      $referrer: '',
    });
  } catch { /* Telemetry must not interrupt setup or its recovery paths. */ }
}

/** Only bounded product states; never send URLs, draft contents, or OAuth tokens. */
export function reportOnboardingProgress(action: string, workspaceId?: string | null, details?: { step: string; view: string }): void {
  if (process.env.REACT_APP_POSTHOG_DISABLED === 'true') return;
  try {
    posthog.capture('onboarding_progress', { action, workspaceId, ...details,
      $current_url: `${window.location.origin}${window.location.pathname}`, $referrer: '' });
  } catch { /* Optional telemetry. */ }
}
